<template>
    <Head title="Visualização de documento" />

    <div class="w-screen min-h-screen bg-gray-200 pt-28 pb-10">
        <header class="p-4 w-full mb-4 bg-white fixed top-0 left-0 z-50">
            <div class="w-full max-w-[900px] mx-auto flex items-center justify-between">
                <img src="/images/logo_header.png" />
        
                <button
                    type="button"
                    class="p-2 text-lg text-blue-900"
                    @click="handleDownload">
                        <font-awesome-icon icon="fa-download" />
                </button>
            </div>
        </header>
    
        <div class="w-full px-4 max-w-[900px] mx-auto overflow-y-auto">

            <div class="fixed top-0 left-0 bottom-0 w-full flex flex-col items-center justify-center" v-show="error">
                <font-awesome-icon icon="fa-circle-exclamation" class="text-blue-900 text-3xl mb-4" />
                <p class="text-lg text-center">Ocoreu um erro ao exibir documento. <br />Tente atualizar a pagina!</p>

                <button
                    type="button"
                    class="p-2 text-2xl text-blue-900 mt-4"
                    @click="handleReloadPage">
                        <font-awesome-icon icon="fa-arrows-rotate" />
                </button>
            </div>

            <div class="fixed top-0 left-0 bottom-0 w-full flex items-center justify-center" v-show="loaddingDocument">
                <div class="spin w-10 h-10 rounded-full border-[5px] border-gray-300 border-r-blue-900"></div>
            </div>

            <vue-pdf-embed 
                v-if="type == 'pdf'"
                :source="link"
                @loaded="() => loaddingDocument = false"
                @loading-failed="handleLoaddindFailed"
                @rendering-failed="handleLoaddindFailed"
                v-show="!loaddingDocument">
            </vue-pdf-embed>

            <div v-else-if="type == 'png' || type == 'jpg'">
                <img class="w-full" :src="link" @load="loaddingDocument = false" />
            </div>

            <div v-else-if="type == 'docx' || type == 'doc'">
                <iframe 
                    :src="`https://view.officeapps.live.com/op/embed.aspx?src=${link}`" 
                    width="100%" 
                    height="1100px" 
                    frameborder="0"
                    @load="loaddingDocument = false">
                </iframe>
            </div>
        </div>
    </div>

</template>


<script>

import { Head } from '@inertiajs/inertia-vue3'
import VuePdfEmbed from 'vue-pdf-embed'

export default {
    components: {
        VuePdfEmbed,
        Head,
    },

    data() {
        return {
            loaddingDocument: true,
            error: false,
            link: null,
            type: null,
        }
    },


    mounted() {
        const url = new URL(window.location.href)

        this.link = url.searchParams.get('link')
        this.type = url.searchParams.get('type')
    },

    methods: {
        handleDownload() {
            window.open( this.link, '_blank' )
        },

        handleReloadPage() {
            window.location.reload()
        },

        handleLoaddindFailed() {
            this.error = true
            this.loaddingDocument = false
        }
    }
}

</script>


<style>

.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.spin {
    animation: spin 1s infinite linear;
}

@keyframes spin {
    100% {
        transform: rotateZ( 360deg );
    }
}

</style>
